import React from 'react';
import PropTypes from 'prop-types';
import { getFixedScore, getSeverityByScore } from './utils';
import * as S from './styled';

const ScoreTag = ({ value, suffix }) => {
  const fixedScore = getFixedScore(value);
  const { borderColor, bgColor } = getSeverityByScore(fixedScore);
  return (
    <S.ScoreTagContainer $bgColor={bgColor} $borderColor={borderColor}>
      {fixedScore}
      {suffix ? <S.ScoreTagSuffix>{suffix}</S.ScoreTagSuffix> : null}
    </S.ScoreTagContainer>
  );
};

ScoreTag.propTypes = {
  value: PropTypes.number.isRequired,
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ScoreTag;
